<template>
  <card>
    <h6 class="mb-5">Valor total</h6>
    <h5
      :class="{
        'text-success': totalInNumber > 0,
        'text-danger': totalInNumber < 0
      }"
    >
      {{ loading ? "-" : total }}
    </h5>
  </card>
</template>

<script>
import { clearObject, formatMoney, removeMask } from "@/functions/helpers";

export default {
  props: {
    filters: {
      type: Object,
      default: () => ({})
    },
    refresh: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: true,
      total: ""
    };
  },
  computed: {
    totalInNumber() {
      return Number(removeMask(this.total));
    }
  },
  watch: {
    refresh(val) {
      if (val) {
        this.request();
      }
    }
  },
  mounted() {
    return this.request();
  },
  methods: {
    request() {
      this.loading = true;

      const filters = {
        ...this.filters,
        status__in: this.filters.status
          ? this.filters.status.join(",")
          : "paid, completed",
        created_at__gte: this.filters.created_at_after,
        created_at__lte: this.filters.created_at_before
      };

      delete filters.status;
      delete filters.created_at_after;
      delete filters.created_at_before;

      this.$store
        .dispatch("sale/getTotal", clearObject(filters))
        .then(response => {
          this.total = "R$ " + formatMoney(response.data.amount__sum);
        })
        .catch(() => {
          this.total = "Erro!";
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
